// A monitored Company's status: the cyan dot, pulsing and glowing, and the
// word, in cyan. The File masthead, the swarm tooltip and the film show it;
// it is not a control. Styles in terminal-theme.css.
export const MonitoringStatus = () => (
  <span className="file-monitor-inline type-micro text-terminal-accent inline-flex items-center gap-1.5">
    <span
      className="monitor-active grid size-4.5 shrink-0 place-items-center"
      aria-hidden="true"
    >
      <span className="monitor-dot" />
    </span>
    <span>Monitoring</span>
  </span>
)
